import { currencyFormatter } from 'src/utils/currency-formatter';
import { multiplierForPeriod } from 'src/utils/rollup';

export default function annotationsForGoals(goals, period, colors) {
  return Object.entries(goals ?? {})
    ?.filter(([category]) => category !== 'INCOME')
    .map(([category, value]) => [category, value * multiplierForPeriod(period)])
    .map(([category, value], index) => ({
      type: 'line',
      id: category,
      borderDash: [6, 6],
      borderDashOffset: 0,
      ...(colors && { borderColor: colors[index % colors.length] }),
      borderWidth: 2,
      label: {
        display: true,
        position: 'end',
        content: () => `🎯 ${category} Goal: ${currencyFormatter.format(value)}`,
      },
      scaleID: 'y',
      value,
    }));
}
